import { FiscalNumber } from "../fiscal-number";

export class FileIndustryProductsDiscounts {
  private file: File;
  private fiscalNumber: FiscalNumber;

  static isCsvExtension(file: File): boolean {
    return file.name.includes(".csv");
  }

  getFile(): File {
    return this.file;
  }

  setFile(file: File): void {
    this.file = file;
  }

  getFiscalNumber(): FiscalNumber {
    return this.fiscalNumber;
  }

  setFiscalNumber(value: FiscalNumber): void {
    this.fiscalNumber = value;
  }

  hasFile(): boolean {
    return !!(this.file && this.fiscalNumber);
  }
}
